<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="data.form.unidades"
                    :validations="validations.unidade"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="infraestruturas"
                    :validations="validations.infraestrutura"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="model.infraestruturaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="data.form.atendimentoMedico.tipos"
                    :validations="validations.tipo"
                    label="Tipo"
                    show-default-option
                    text-field="nome"
                    v-model="model.tipoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { object } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
                tipo: { required: true },
            }
        },
        infraestruturas() {

            if (this.model.unidadeId) {

                return this.data.form.unidades.find(u => u.id === this.model.unidadeId).infraestruturas
            }

            return []
        },
        hasIndex() {

            return this.index !== null
        }
    },
    created() {

        this.load()
    },
    data: () => ({
        model: {
            unidadeId: null,
            infraestruturaId: null,
            tipoId: null,
        },
    }),
    methods: {
        load() {

            if (this.hasIndex) {

                const data = this.data.model.tipos[this.index]

                this.model.unidadeId = data.unidade.id

                this.$nextTick(() => {

                    this.model.infraestruturaId = data.unidade.infraestrutura.id
                    this.model.tipoId = data.tipo.id
                })
            }
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (this.hasInfraestruturaParametrizada()) {

                        this.showValidationNotification(
                            'Tipo de atendimento médico já definido para este local de atendimento.'
                        )

                        return
                    }

                    const unidade = this.data.form.unidades.find(u => u.id === this.model.unidadeId)
                    const infraestrutura = unidade.infraestruturas.find(i => i.id === this.model.infraestruturaId)
                    const tipo = this.data.form.atendimentoMedico.tipos.find(t => t.id === this.model.tipoId)

                    const param = {
                        unidade: {
                            id: unidade.id,
                            nomeFantasia: unidade.nomeFantasia,
                            infraestrutura: {
                                id: infraestrutura.id,
                                nome: infraestrutura.nome,
                            },
                        },
                        tipo: {
                            id: tipo.id,
                            nome: tipo.nome,
                        },
                    }

                    if (this.hasIndex) {

                        this.$set(this.data.model.tipos, this.index, this.clone(param))
                    }
                    else {

                        this.data.model.tipos.push(this.clone(param))
                    }

                    this.$emit('save', this.clone(param))
                })
        },
        hasInfraestruturaParametrizada() {

            return this.data.model.tipos.find((tipo, i) => i !== this.index
                && tipo.unidade.infraestrutura.id === this.model.infraestruturaId)
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
        index: { type: Number, default: null },
    },
    watch: {
        'model.unidadeId': function () {

            this.model.infraestruturaId = null
        },
    },
}
</script>
